import React, { useState } from "react";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { notify, formDataHelper } from "../../../../util/helpers";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { DatePicker, DateRangePicker } from "rsuite";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { CBadge } from "@coreui/react";
import "../../patient/PatientStyles.css";
import moment from "moment";
import {
  paymentTypeOptions,
  typeOptions,
} from "../../../../constants/constants";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "90vh",
  },
};

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{ color: "white", backgroundColor: "#2bc2f7" }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const HorizontalSwitcherComponent = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid my-2">
      <div className="d-flex">
        <Tab
          text={"Basic Details"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        <Tab
          text={"Card Payment"}
          callBack={() => {
            setCurrentTab(2);
          }}
          active={currentTab === 2}
        />
      </div>
    </div>
  );
};

const CreateHealthCareGroup = ({ modalIsOpen, setIsOpen }) => {
  Modal.setAppElement("#root");
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);

  const dispatch = useDispatch();

  function closeModal() {
    if (loading) {
      notify("Please wait while the HealthCare Group is being created", "info");
      return;
    }
    setCurrentTab(1);
    setIsOpen(false);
  }
  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      if (loading) {
        notify(
          "Please wait while the Clinic details are being recorded",
          "info"
        );
        return;
      }
      setLoading(true);
      let formData = new FormData(e.target);
      const data = formDataHelper(formData, true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      notify("Something went wrong! Try again later!", "error");
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">Create Clinic</h3>
            </div>
            <HorizontalSwitcherComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
            <form onSubmit={handleSubmit} className="container-fluid p-1 row">
              <div
                style={{
                  margin: "0px",
                  padding: "0px",
                  width: "100%",
                  display: currentTab === 1 ? "inline-flex" : "none",
                }}
                className="row"
              >
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="form-group py-3">
                    <label>Name Of HealthCare Group *</label>
                    <input
                      tabindex="1"
                      required
                      name="name"
                      id="name"
                      placeholder="Enter HealthCare Group Name"
                    />
                  </div>

                  <div className="form-group py-3">
                    <label>Street Address 1</label>
                    <input
                      tabindex="3"
                      name="street_address_1"
                      id="street_address_1"
                      required
                      placeholder="Lane, bulding, house no."
                    />
                  </div>

                  <div className="form-group py-3">
                    <label>City</label>
                    <input
                      tabindex="5"
                      name="city"
                      id="city"
                      maxLength={14}
                      placeholder="Enter City Name"
                    />
                  </div>

                  <div className="form-group py-3">
                    <label>Country</label>
                    <input
                      tabindex="7"
                      name="Country"
                      id="Country"
                      maxLength={14}
                      placeholder="Enter Country"
                    />
                  </div>

                  <div className="form-group py-3">
                    <label>Primary Contact</label>
                    <input
                      tabindex="9"
                      name="cell_number"
                      id="cell_number"
                      maxLength={10}
                      minLength={10}
                      placeholder="Enter Phone Number"
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>Rose Sales Team Manager</label>
                    <input
                      tabindex="11"
                      name="rose_sales_member"
                      id="rose_sales_member"
                      required
                      placeholder="Enter Full Name"
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="form-group py-3">
                    <label>Payment Type *</label>
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          border: "0px",
                          borderBottom: "1px solid #94A3B8",
                          borderRadius: "0px",
                        }),
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      value={selectedPaymentType}
                      onChange={(e) => {
                        setSelectedPaymentType(e);
                      }}
                      options={paymentTypeOptions}
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>Type</label>
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          border: "0px",
                          borderBottom: "1px solid #94A3B8",
                          borderRadius: "0px",
                        }),
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      value={selectedType}
                      onChange={(e) => {
                        setSelectedType(e);
                      }}
                      options={typeOptions}
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>Street Address 2</label>
                    <input
                      tabindex="4"
                      name="street_address_2"
                      id="street_address_2"
                      required
                      placeholder="Continue with address"
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>State</label>
                    <input
                      tabindex="6"
                      name="state"
                      id="state"
                      maxLength={14}
                      placeholder="Enter State Name"
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>Zip Code</label>
                    <input
                      tabindex="8"
                      name="zip_code"
                      id="zip_code"
                      maxLength={14}
                      placeholder="Enter Zip Code"
                    />
                  </div>
                  <div className="form-group py-3">
                    <label>Primary Email</label>
                    <input
                      tabindex="10"
                      type="email"
                      placeholder="Enter Email Address"
                      name="email"
                      id="email"
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  margin: "0px",
                  padding: "0px",
                  width: "100%",
                  display: currentTab === 2 ? "inline-flex" : "none",
                }}
              >
                <div className="container">
                  <div className="container-fluid">
                    <div className="form-group py-3 w-100">
                      <label>Name on Card</label>
                      <input
                        tabindex="1"
                        placeholder="Enter Cardholder's Name"
                        name="cardholder_name"
                        id="cardholder_name"
                      />
                    </div>
                  </div>
                  <div className="container-fluid">
                    <div className="form-group py-3 w-100">
                      <label>Card Details</label>
                      <input
                        tabindex="2"
                        placeholder="0000-0000-0000-0000"
                        name="card_number"
                        id="card_number"
                      />
                    </div>
                  </div>
                  <div className="container-fluid">
                    <div className="form-group py-3 w-100">
                      <label>Billing Email Address</label>
                      <input
                        tabindex="3"
                        type="email"
                        placeholder="Enter Billing Email Address"
                        name="billing_email"
                        id="billing_email"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="container-fluid w-100 d-flex justify-content-end"
                style={{ gap: "30px" }}
              >
                <button
                  className="btn alternative-btn"
                  style={{ padding: "10px 20px", width: "20%" }}
                  onClick={() => {
                    if (currentTab === 1) {
                      closeModal();
                    } else {
                      setCurrentTab(1);
                    }
                  }}
                >
                  {currentTab === 1 ? "Cancel" : "Back"}
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-btn"
                  style={{ padding: "10px 20px !important", width: "20%" }}
                >
                  {currentTab === 1 ? "Next" : "Submit"}
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default CreateHealthCareGroup;
